import { TaskTrackerItemState } from "../../enum/task-tracker-item-state";

/**подзадача */
export class TaskTrackerItemSubItem {
    position: number = 0;
    name: string = '';
    state: TaskTrackerItemState = TaskTrackerItemState.Undef;

    menuOpened: boolean = false;
    edit: boolean = false;
    deleted: boolean = false;

}
